import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Container, Typography } from '@mui/material';
import { Lock as LockIcon } from '@mui/icons-material';

const Forbidden = () => {
  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          textAlign: 'center',
        }}
      >
        <LockIcon sx={{ fontSize: 60, color: 'error.main', mb: 2 }} />
        <Typography variant="h1" color="error" sx={{ fontSize: '8rem', fontWeight: 600 }}>
          403
        </Typography>
        <Typography variant="h4" gutterBottom>
          Acceso Prohibido
        </Typography>
        <Typography variant="body1" color="textSecondary" paragraph>
          No tienes permisos para acceder a esta página o recurso.
        </Typography>
        <Typography variant="body2" color="textSecondary" paragraph>
          Si crees que esto es un error, por favor contacta al administrador del sistema.
        </Typography>
        <Button
          component={RouterLink}
          to="/dashboard"
          variant="contained"
          color="primary"
          sx={{ mt: 2 }}
        >
          Volver al Dashboard
        </Button>
      </Box>
    </Container>
  );
};

export default Forbidden;